import { monthNames } from "../constants/constants";
import { isKhaliCheck } from "./utils";
// Get formated values in M,K,B
export const getFormattedValue = (value, format, floor) => {
    switch (format) {
        case "money": {
            if ((value >= 10 ** 12 && value > 0) ||
                (value < -(10 ** 12) + 1 && value < 0)) {
                value = +roundNum(value / 10 ** 11, 1, 0) / 10;
                return `$${value}T`;
            }
            if ((value >= 10 ** 9 && value > 0) ||
                (value < -(10 ** 9) + 1 && value < 0)) {
                value = +roundNum(value / 10 ** 8, 1, 0) / 10;
                return `$${value}B`;
            }
            if ((value >= 10 ** 6 && value > 0) ||
                (value < -(10 ** 6) + 1 && value < 0)) {
                value = +roundNum(value / 10 ** 5, 1, 0) / 10;
                return `$${value}M`;
            }
            if ((value >= 1000 && value > 0) || (value < -999 && value < 0)) {
                value = +roundNum(value / 10 ** 2, 1, 0) / 10;
                return `$${value}K`;
            }
            return `$${roundNum(value, 0, 0)}`;
        }
        case "num":
            return value;
        case "percent":
            return `${Math.round(value * 1000) / 10}%`;
        default:
            return value;
    }
};
// Remove comma for formatted string
export const removeCommaString = (value) => parseFloat(value.replace(/\$|,/g, ""));
export const generalMoney = (value) => `$${formatCommaString(roundNum(value, 0, 2, true))}`;
// Add commas to int/float value
export const formatCommaString = (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// Round of the number
export const roundNum = (num, pow, tofixed = 2, abs = false, parseInt = false) => {
    const rounded = ((+(isKhaliCheck(num) ? 0 : abs ? Math.abs(+num) : num) * 10 ** pow) /
        10 ** pow).toFixed(tofixed);
    return parseInt ? +rounded : rounded;
};
// Convert to title case
export function toTitleCase(str) {
    return str?.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
// Removes the time from date and converts it to month name
export function getFormatedDate(date, year = false, monthSlice = false) {
    const formattedDate = date.includes(" ") ? date?.split(" ")[0] : date;
    const d = new Date(formattedDate);
    const month = monthNames[d.getMonth()];
    const myYear = year ? ` ${d.getFullYear()}` : "";
    const mon = monthSlice ? month.slice(0, 3) : month;
    return `${year ? mon.toUpperCase() : mon} ${d.getDate()} ${myYear}`;
}
